import { Button, Drawer, makeStyles, Paper, Typography } from '@material-ui/core';
import { noop } from '@thalesrc/js-utils';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import TextField from 'Common/Form/TextField';

const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: 320,
  },
  paper: {
    maxWidth: 320,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

interface SupportDrawerProps {
  opened: boolean;
  onClose(): void;
}

export default function SupportDrawer({ opened = false, onClose = noop }: SupportDrawerProps) {
  const classes = useStyles();
  const formMethods = useForm();

  function handleFormSubmit(value: any) {
    // TODO: bind xhr requests
    // tslint:disable-next-line:no-console
    console.log(value);
  }

  return (
    <Drawer anchor="right" open={opened} onClose={onClose} PaperProps={{ className: `${classes.container} px-2 py-4` }}>
      <Typography variant="h5" className="text-center">
        ARTI METRİK <br />
        DESTEK
      </Typography>
      <Paper elevation={3} className={classes.paper + ' mt-2 p-4'}>
        Aşağıdaki form üzerinden yazılım ve destek ekibimize bildiriminizi gönderebilirsiniz.
      </Paper>
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(handleFormSubmit)} className="mt-4">
          <TextField name="subject" label="Konu" className="mb-2" rules={{ required: 'Bu alan zorunlu' }} />
          <TextField name="description" label="Açıklama" className="mb-2" rows={5} rules={{ required: 'Bu alan zorunlu' }} />
          <footer className="text-right">
            <Button type="submit" variant="contained" color="primary" disabled={!!Object.keys(formMethods.errors).length}>
              Gönder
            </Button>
          </footer>
        </form>
      </FormProvider>
    </Drawer>
  );
}
